import BackupWallet from '../wallet/backup';
export default BackupWallet;
